import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import { colors } from '../../../styles/colors';
import { IStyleProps } from './types';

const useStyles = makeStyles({
  cardAccordion: {
    boxShadow:
      '0px 4px 5px rgba(0, 0, 0, 0.14),0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)',
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    position: 'relative',
    backgroundColor: (props: IStyleProps) => `${props.color}`,
    border: '1px solid transparent',
    transition: 'border 150ms',
    padding: '16px',

    '&:hover': {
      border: (props: IStyleProps) =>
        `1px solid ${props.clickable ? props.iconColor : 'transparent'}`,
      cursor: (props: IStyleProps) =>
        `${props.clickable ? 'pointer' : 'default'}`,
    },

    '& .MuiAccordionSummary-root': {
      padding: '0',
      minHeight: 'auto',
      '& .MuiIconButton-root': {
        padding: '0',
        margin: '0',
        alignSelf: 'start',
      },
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 'auto',
    },

    '& .MuiAccordionSummary-content': {
      margin: '0',
    },

    '& .MuiAccordionDetails-root': {
      padding: '0',
      '& .MuiPaper-root': {
        paddingTop: '16px',
      },
    },
  },

  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  headerIcon: {
    fontSize: fonts.sizes.xlarge,
    color: (props: IStyleProps) => `${props.iconColor}`,
    alignSelf: 'start',
  },

  headerText: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& strong': {
      fontSize: fonts.sizes.small,
      marginBottom: (props: IStyleProps) => (props.hasSubtitle ? '8px' : '0'),
    },

    '& span': {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      fontSize: fonts.sizes.small,
      paddingRight: '1rem',
      paddingLeft: '1rem',
    },
  },
  isLoading: {
    color: colors.loadingGray,
  },
});

export default useStyles;
